// import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { Card, CardContent } from '@/components/ui/card'

import { ProductStatus, ProductFilters } from './product.types'

interface ProductsFilterProps {
  filters: ProductFilters
  onFiltersChange: (filters: Partial<ProductFilters>) => void
  onCreateNew: () => void
}

const STATUS_TABS = [
  { label: 'ทั้งหมด', value: ProductStatus.ALL },
  { label: 'เปิดใช้งาน', value: ProductStatus.ACTIVE },
  { label: 'ปิดใช้งาน', value: ProductStatus.INACTIVE },
] as const

export default function ProductsFilter({
  filters,
  onFiltersChange,
  onCreateNew,
}: ProductsFilterProps) {
  // const [searchInput, setSearchInput] = useState(filters.search)

  // const handleSearchSubmit = (e: React.FormEvent) => {
  //   e.preventDefault()
  //   onFiltersChange({
  //     search: searchInput,
  //     page: 1, // Reset to first page when searching
  //   })
  // }

  const handleStatusChange = (status: ProductStatus) => {
    onFiltersChange({
      status,
      page: 1, // Reset to first page when filtering
    })
  }

  return (
    <Card>
      <CardContent>
        <div className="flex flex-col gap-6">
          {/* Header with Add Button */}
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-black">รายการสินค้า</h2>
            <Button onClick={onCreateNew}>เพิ่มสินค้า</Button>
          </div>

          <Separator className="border-gray-200" />

          {/* Search Bar */}
          {/* <form onSubmit={handleSearchSubmit} className="flex gap-2">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
              <Input
                placeholder="ค้นหาจากชื่อสินค้า..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="pl-10 rounded-lg border"
              />
            </div>
            <Button type="submit" variant="outline">
              ค้นหา
            </Button>
          </form> */}

          {/* Status Filter Tabs */}
          <div className="flex gap-2 flex-wrap">
            {STATUS_TABS.map((tab) => (
              <Button
                key={tab.value}
                variant={filters.status === tab.value ? 'default' : 'outline'}
                onClick={() => handleStatusChange(tab.value)}
                className={`rounded-lg px-4 py-2 ${
                  filters.status === tab.value
                    ? 'bg-primary text-background'
                    : 'border text-black hover:bg-gray-50'
                }`}
              >
                {tab.label}
              </Button>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
